module.exports = __webpack_public_path__ + "static/img/main.5b6e23d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/10/main.png
// module id = QwGs
// module chunks = 1